import axios from 'axios';
import {clarify} from "../utils/clear";

class MailApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }

    send(body) {
        return axios.post(`${this.endpoint}/mail/send`, body).then(response => response.data);
    }

    history(searchParams) {
        const params = new URLSearchParams(clarify(searchParams));
        return axios.get(`${this.endpoint}/mail/history`, {params}).then(response => response.data);
    }

    historyDetailList(requestId,paramDetail) {
        return axios.get(`${this.endpoint}/mail/history/${requestId}/detail/list?page=${paramDetail.page-1}&size=${paramDetail.size}&sendStatus=${paramDetail.sendStatus}` ).then(response => response.data);
    }


    uploadImage(f) {
        const formData = new FormData();
        formData.append('file', f);
        return axios.post(`${this.endpoint}/mail/upload/image`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => response.data);
    }

    uploadImages(files) {
        const formData = new FormData();
        files.forEach(f => formData.append('file', f));
        return axios.post(`${this.endpoint}/mail/upload/image`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => response.data);
    }
    historyDownload(id, params) {
        return axios.get(
            `${this.endpoint}/mail/history/${id}/detail/list/download/excel`,
            {
                responseType: 'arraybuffer',
                headers: {
                  'Accept': 'application/vnd.ms-excel',
                },
                params,
            }
        );
    }
}

export default new MailApi();
